import React, { type ComponentProps } from 'react';
import { defineMessages } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import { Button } from '@sg/garnish';

import { useFeatureFlag } from '@order/LaunchDarkly';

export const OrderPlaybackGoBack = (props: OrderPlaybackGoBackProps) => {
  const { goBack, isDisabled } = props;

  const shouldUseCautionPalette = useFeatureFlag(
    'CELS-4534-order-playback-cta-caution-palette-enabled',
  );

  const palette: ComponentProps<typeof Button>['palette'] =
    shouldUseCautionPalette ? 'cautionFill' : 'kale';

  return (
    <Button
      size="small"
      palette={palette}
      disabled={isDisabled}
      onPress={goBack}
    >
      <FormattedMessage {...messages.goBack} />
    </Button>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  goBack: {
    defaultMessage: 'Go back',
    description: 'Bag | Order playback | Go back',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type OrderPlaybackGoBackProps = {
  isDisabled: boolean;
  goBack: () => void;
};
